import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import servicesSlice from './servicesSlice';
import claimsSlice from './claimsSlice';
import managerSlice from './managerSlice';
import responsibleSlice from './responsibleSlice';
import suggestionSlice from './suggestionSlice';
import claimManagerSlice from './claimManagerSlice';
import claimHistorySlice from './claimHistorySlice';
import adminNotificationSlice from './notificationSlice';
import jobPostsSlice from './jobPostSlice';
import collaborationSlice from './collaborationSlice';
import areaSectionsSlice from './areaSectionsSlice';
import reservationSlice from './reservationSlice';
import serviceRequestSlice from './serviceRequestSlice';
import staffRatingSlice from './staffRatingSlice';
import staffMonthlyReviewSlice from './staffMonthlyReviewSlice';
import staffTrainingReportSlice from './staffTrainingReportSlice';
import staffAnnualReviewSlice from './staffAnnualReviewSlice';
import favoriteUsersSlice from './favoriteUsersSlice';
import attendanceSlice from './attendanceSlice';
import staffAccountSlice from './staffAccountSlice';
import uiSlice from './uiSlice';
import { setStore } from './storeRef';

export const store = configureStore({
  reducer: {
    ui: uiSlice,
    user: authSlice,
    manager: managerSlice,
    claimManager: claimManagerSlice,
    responsible: responsibleSlice,
    services: servicesSlice,
    claims: claimsSlice,
    suggestions: suggestionSlice,
    notification: adminNotificationSlice,
    history: claimHistorySlice,
    jobPosts: jobPostsSlice,
    collaborations: collaborationSlice,
    areaSections: areaSectionsSlice,
    reservations: reservationSlice,
    serviceRequests: serviceRequestSlice,
    staffRating: staffRatingSlice,
    staffMonthlyReview: staffMonthlyReviewSlice,
    staffTrainingReport: staffTrainingReportSlice,
    staffAnnualReview: staffAnnualReviewSlice,
    favoriteUsers: favoriteUsersSlice,
    attendance: attendanceSlice,
    staffAccount: staffAccountSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

setStore(store);
